export default __webpack_public_path__ + "7f839a8652da29745ce4260846c3f88e.woff2";